import { checkPermissions } from "../../security"
import { 
  currencyCheck,
  PERMISSIONS,
} from "../../strings"
import { dateFormatter } from "../formatters"
import { actions } from "./actions"
import closingGetters from "./getters"


export const columnDefs = ({openDetailModal, handleFilter, getValues})=> ([
    {
      headerName: 'Campaña',
      headerClass: 'column-group-1',
      children: [
        {
          headerName: 'ID',
          valueGetter: closingGetters.campaigns.getId,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: 'left',
          lockPinned: true,
          width: 150
        },
        //Esta columna se va a filtrar
        {
          headerName: 'Nombre campaña',
          valueGetter: closingGetters.campaigns.getName,
          filter: false,
          width: 300,
          wrapText: true
        },
        //Esta columna se va a filtrar
        {
            headerName: 'Multimes',
            valueGetter: closingGetters.campaigns.getMultiMonth,
            filter: true,
            floatingFilterComponentParams: {
              handleFilter,
              suppressFilterButton: true,
              getValues,
              columnName: 'is_campaign_longer_than_one_month'
            },
            floatingFilterComponent: "booleanFilter",
            width: 200,
            wrapText: true
        },
        {
          headerName: 'DSP',
          valueGetter: closingGetters.campaigns.getExternalDsp,
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'external_dsp_name',
            placeholder: 'Buscar DSP'
          },
          floatingFilterComponent: "textFilter",
          width: 500,
          wrapText: true
        },
        {
          headerName: 'Modelo de negocio',
          valueGetter: closingGetters.campaigns.getBusinessModel,
          pinned: 'left',
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'is_external_dsp',
            items: [
              {value: null, text: 'Todos'},
              {value: 0, text: 'DSP propio'},
              {value: 1, text: 'DSP externo'},
            ]
          },
          floatingFilterComponent: "booleanFilter",
          width: 200,
          wrapText: true
        },
        {
          headerName: 'Fecha de Inicio',
          valueGetter: closingGetters.campaigns.getFromDate,
          valueFormatter: dateFormatter,
          filter: false,
          width: 180
        },
        {
          headerName: 'Fecha de Fin',
          valueGetter: closingGetters.campaigns.getToDate,
          valueFormatter: dateFormatter,
          filter: false,
          width: 150
        },
        {
          headerName: 'Tipo de campaña',
          valueGetter: closingGetters.campaigns.getCampaignType,
          filter: false,
          width: 150
        },
        {
          headerName: 'Comentario',
          valueGetter: closingGetters.campaigns.getComment,
          cellRenderer: 'commentRenderer',
          hide: !checkPermissions([PERMISSIONS.EDIT_CAMPAIGN_COMMENTS]),
          filter: false,
          cellRendererParams: {
            campaignId: closingGetters.campaigns.getId,
          },
          width: 250,
          wrapText: true,
        },

      ]
    },
    {
      headerName: 'Pantalla',
      headerClass: 'column-group-4',
      children: [
        //Esta columna se va a filtrar
        {
          headerName: 'ID Empresa',
          valueGetter: closingGetters.company.getId,
          filter: false,
          width: 150
        },
        
        //Esta columna se va a filtrar
        {
          headerName: 'Empresa Pantallero',
          valueGetter: closingGetters.company.getName,
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'company_name',
            placeholder: 'Buscar empresa'
          },
          floatingFilterComponent: "textFilter",
          width: 200
        },
        //Esta columna se va a filtrar
        {
          headerName: 'Holding',
          valueGetter: closingGetters.company.getHolding,
          filter: false,
          width: 200
        },
        //Esta columna se va a filtrar
        {
          headerName: 'País',
          valueGetter: closingGetters.company.getCountry,
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
          },
          floatingFilterComponent: "countryFilter",
          width: 150
        }
      ]
    },
    {
      headerName: 'Operación',
      headerClass: 'column-group-2',
      children: [
        {
          headerName: 'Garantizado',
          valueGetter: closingGetters.operation.getGuaranteed,
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'is_guaranteed',
          },
          floatingFilterComponent: "booleanFilter",
          width: 120,
          wrapText: true
        },
        //Esta columna se va a filtrar
        {
          headerName: 'Divisa',
          valueGetter: closingGetters.operation.getCurrencyToPay,
          width: 100,
          filter: false
        },
        {
            headerName: 'Estimado',
            valueGetter: closingGetters.operation.getAmountBudgeted,
            valueFormatter: currencyCheck,
            filter: false,
            width: 350,
            colId: 'paid_amount',
        },
        {
            headerName: 'Final',
            valueGetter: closingGetters.operation.getAmountFinal,
            valueFormatter: currencyCheck,
            filter: false,
            width: 350,
            colId: 'final_price',
        },
        {
            headerName: 'Tax',
            valueGetter: closingGetters.operation.getTax,
            width: 150
        },
        {
            headerName: 'Final + Impuestos',
            valueFormatter: currencyCheck,
            valueGetter: closingGetters.operation.getFinalWithTax,
            width: 150
        },
        //BACKEND REQUIRED
        {
            headerName: 'Monto OC',
            valueGetter: closingGetters.other.getTotalAmountOC,
            valueFormatter: currencyCheck,
            width: 150
        },
        {
            headerName: 'Consumo externo',
            valueGetter: closingGetters.operation.getExternalAmountConsumed,
            width: 200
        },
        {
          headerName: 'Consumido',
          valueGetter: closingGetters.operation.getAmountConsumed,
          valueFormatter: currencyCheck,
          filter: false,
          width: 200,
          colId: 'total_price_consumed'
        },
        {
          headerName: 'Coincide',
          valueGetter: closingGetters.operation.getMatchData,
          width: 150,
          cellRenderer: actions.render.renderMatchData
        },
        {
          headerName: 'ODC Cerrada',
          valueGetter: closingGetters.other.getPoIsClosed,
          cellRenderer: 'closingsChips',
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'po_is_closed',
          },
          floatingFilterComponent: "booleanFilter",
          width: 150
        },
        {
          headerName: 'Enviada vía mail',
          valueGetter: closingGetters.other.getPoIsSent,
          cellRenderer: 'closingsChips',
          filter: true,
          floatingFilterComponentParams: {
            handleFilter,
            suppressFilterButton: true,
            getValues,
            columnName: 'po_email_send',
          },
          floatingFilterComponent: "booleanFilter",
          width: 150
        },
        {
          headerName: 'Cierre',
          pinned: 'left',
          valueGetter: closingGetters.other.getPurchaseOrderData,
          cellRenderer: actions.render.renderDetailButton(openDetailModal),
          width: 150
        },
        {
          headerName: 'Tasa',
          valueGetter: closingGetters.operation.getRateFrom,
          width: 150
        },
      ]
    },
  ])